import router from "@/router/index";
import store from "@/store/index";
import { Key, Cookie } from "@/utils/storage/cookie";
import ProjectUtils from "@/utils/string/StringUtils";

// 全局前置守卫，在路由跳转前进行权限验证和页面初始化
router.beforeEach((to, from, next) => {
  // 从localStorage中获取libid
  const libid = localStorage.getItem('libid');
  console.log(libid, "libid");
  let isToken = "";
  // 判断是否是OPAC检索页面，如果是则直接放行
  if (to.path == "/BookSearchs" || to.path == "/BookRetrieval") {
    next();
    return;
  } else {
    // PC端登录的token，从Cookie中获取
    isToken = Cookie.get(Key.token);
  }

  // 如果token不存在（未登录）
  if (isToken == undefined) {
    // 如果目标路径是登录页，则直接放行
    if (to.path == "/login" || to.path == "/JKlogin" || to.path == "/YSlogin" || to.path == "/GXlogin") {
      next();
    } else {
      // 如果libid为JK，则重定向到JK登录页，否则重定向到普通登录页
      if (libid == "JKQT") {
        next("/JKlogin");
      } else if (libid == "YSXT") {
        next("/YSlogin");
      } else if (libid == "GXQT") {
        next("/GXlogin");
      } else {
        next("/login");
      }
    }
    return;
  }

  // 如果token存在（已登录）
  // 检查是否是异常页面（404或403），如果是则直接放行
  if (to.path == "/excption/404" || to.path == "/excption/403") {
    next();
    return;
  }

  // 如果已登录且目标路径是登录页，则重定向到欢迎页
  if (to.path == "/login" || to.path == "/JKlogin" || to.path == "/YSlogin" || to.path == "/GXlogin") {
    next("/home/Welcome");
  }

  // 如果store中的init状态为false，表示菜单权限尚未初始化
  if (store.state.init === false) {
    // 调用GetUserMenuSource action获取用户菜单权限
    store.dispatch("GetUserMenuSource").then(res => {
      if (res.status === 200) {
        // 获取路由数据并动态添加路由
        const routeData = store.state.routerAddrSet;
        routeData.forEach(item => {
          router.addRoute("home", item);
        });
        // 跳转到目标路径
        next(to.path);
      } else {
        // 菜单权限获取失败，显示错误信息
        ElMessage({
          message: "加载菜单权限信息失败，后台服务异常！",
          type: "error"
        });
      }
    });
  } else {
    // 如果store中的init状态为true，表示菜单权限已初始化
    // 如果目标路径是欢迎页，则直接放行
    if (to.path === "/home/Welcome") {
      next();
    } else {
      // 检查用户是否有权限访问目标路径
      let toPatn = to.path.split("/");
      const path = toPatn[toPatn.length - 1];
      const isRouter = store.state.routSet.find(item => item === path);
      // 如果目标路由存在于用户权限列表中
      if (isRouter != undefined) {
        // 查找对应的路由限制信息
        const routerLimits = ProjectUtils.Fndata(store.state.menusSourceTree, isRouter);
        // 如果找到路由限制且包含id，则更新页面id
        if (routerLimits && routerLimits[0].id) {
          store.dispatch("getPageId", routerLimits[0].id);
        }
        // 放行
        next();
      } else {
        // 如果没有权限，重定向到403页面
        next("/excption/403");
      }
    }
  }
});
export default router;